import type { AdProvider } from '../../lib/adNetwork.hooks.js';

export const PROVIDER_LABEL: Record<AdProvider, string> = {
  meta: 'Meta Ads',
  linkedin: 'LinkedIn',
  google: 'Google Ads',
  tiktok: 'TikTok Ads',
};

export const PROVIDER_DESCRIPTION: Record<AdProvider, string> = {
  meta: 'Facebook & Instagram campaigns, creatives and performance.',
  linkedin: 'Sponsored content & lead-gen across LinkedIn.',
  google: 'Search, Display and Display & Video 360 campaigns.',
  tiktok: 'In-feed ads, Spark Ads and creative performance.',
};

export const ALISON_USER_TENANT_NOT_ALLOWED = 'alison_user_tenant_not_allowed';
export const ALISON_USER_TENANT_MESSAGE =
  'Alison team accounts can only connect networks for Alison test clients in production.';

export const SUPPORTED_PROVIDERS: readonly AdProvider[] = Object.keys(
  PROVIDER_LABEL,
) as AdProvider[];

// Meta links under better-auth's native "facebook" id; the rest are our own
// generic-OAuth entries, suffixed because "google" is the SSO login button.
export const OAUTH_PROVIDER: Record<
  AdProvider,
  'facebook' | 'linkedin' | 'google-ads' | 'tiktok-ads'
> = {
  meta: 'facebook',
  linkedin: 'linkedin',
  google: 'google-ads',
  tiktok: 'tiktok-ads',
};

export function authorizationErrorMessage(code: string): string {
  return code === ALISON_USER_TENANT_NOT_ALLOWED
    ? ALISON_USER_TENANT_MESSAGE
    : "Authorization didn't complete.";
}

export function matchesProviderSearch(provider: AdProvider, query: string): boolean {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return true;
  return `${PROVIDER_LABEL[provider]} ${PROVIDER_DESCRIPTION[provider]}`
    .toLowerCase()
    .includes(normalized);
}
